import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// The @emergentbase/visual-edits dev tool intercepts both fetch AND XHR,
// consuming response bodies (especially on error responses) before Supabase
// can read them. We use a duck-typed response object whose body methods read
// from a closure, so they can be called multiple times without stream errors.
function xhrFetch(input, init = {}) {
    return new Promise((resolve, reject) => {
        const url = typeof input === "string" ? input : input.url;
        const xhr = new XMLHttpRequest();
        xhr.open(init.method || "GET", url);
        xhr.responseType = "arraybuffer";

        const headers = init.headers || {};
        const entries = headers instanceof Headers
            ? [...headers.entries()]
            : Object.entries(headers);
        entries.forEach(([k, v]) => xhr.setRequestHeader(k, v));

        xhr.onload = () => {
            const buffer = xhr.response; // ArrayBuffer — always available on XHR
            const text = new TextDecoder().decode(buffer);

            const responseHeaders = new Headers();
            xhr.getAllResponseHeaders().trim().split(/[\r\n]+/).forEach(line => {
                const idx = line.indexOf(": ");
                if (idx > 0) responseHeaders.set(line.slice(0, idx), line.slice(idx + 2));
            });

            // Duck-typed Response: body methods read from a captured string,
            // so they work correctly even if called multiple times.
            resolve({
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                headers: responseHeaders,
                url,
                json: async () => { try { return JSON.parse(text); } catch { return { error: "parse_error", message: text || "Unknown error" }; } },
                text: async () => text,
                arrayBuffer: async () => buffer.slice(),
                blob: async () => new Blob([buffer]),
                clone() { return { ...this }; },
            });
        };

        xhr.onerror = () => reject(new TypeError("Network request failed"));
        xhr.ontimeout = () => reject(new TypeError("Network request timed out"));
        xhr.send(init.body ?? null);
    });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    global: { fetch: xhrFetch },
});
